import { render, staticRenderFns } from "./trainProgramAddOrUpdate.vue?vue&type=template&id=e7bdfe26"
import script from "./trainProgramAddOrUpdate.vue?vue&type=script&lang=js"
export * from "./trainProgramAddOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports